import { StorageKeys } from '@/lib/config';

/**
 * Per-tenant feature toggles, advertised by the server in the /api/app-version
 * response ("Features" section of the middleware's appsettings) and cached in
 * localStorage so they apply offline and at boot. Every flag defaults to the
 * historical behavior, so an older middleware (no features block) or a fresh
 * device behaves exactly as before the toggle existed.
 */
export interface FeatureFlags {
  /** The REMOVE DEL button on the delivery list (some customers use it, others do not). */
  removeFromDeliveryList: boolean;
}

const DEFAULTS: FeatureFlags = {
  removeFromDeliveryList: true,
};

export function getFeatures(): FeatureFlags {
  try {
    const raw = localStorage.getItem(StorageKeys.features);
    if (!raw) return DEFAULTS;
    return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<FeatureFlags>) };
  } catch {
    return DEFAULTS;
  }
}

/** Persist the server-advertised flags (called from the version check). */
export function storeFeatures(flags: Partial<FeatureFlags> | undefined): void {
  if (!flags) return;
  try {
    localStorage.setItem(
      StorageKeys.features,
      JSON.stringify({ ...getFeatures(), ...flags }),
    );
  } catch {
    /* storage unavailable */
  }
}
